export default __webpack_public_path__ + "static/media/Bracers of Untamed Violence.50845ef5.jpg";